import React, { useState, useEffect } from "react";
import PubSub from "pubsub-js";
import CardAction from "../../molecules/CardAction";
import Item from "../../atoms/Item";
import { ROUTE_REDIRECT_OFFER } from "../../../shared/constants";
import QuickOfferTotal from "./QuickOfferTotal";
import QuickOfferFields from "./QuickOfferFields";
import Loading from "../../../../shared/Loading/Loading";
import { getPricesQuickSale, getFidelities } from "../../../shared/requests-api";
import { getUserToken } from "../../../shared/utils";
import { redirectToLogin } from "../../../../../js/shared/utils";

const QuickOfferCard = () => {
	const defaultFidelity = {
		id: 0,
		valMinMiles: 3500,
		label: "\u00A0"
	};

	const [loading, setLoading] = useState(false);
	const [userInteracted, setUserInteracted] = useState(false);
	const [quantMiles, setQuantMiles] = useState("");
	const [step, setStep] = useState(1);
	const [fidelitySelected, setFidelitySelected] = useState(defaultFidelity);
	const [fidelityPrice, setFidelityPrice] = useState({});
	const [prices, setPrices] = useState([]);
	const [fidelities, setFidelities] = useState([]);

	useEffect(() => {
		let loading = 2;
		setLoading(true);
		const fetchPrices = async () => {
			loading--;
			const result = await getPricesQuickSale();
			setPrices(result.data);
			setLoading(loading !== 0);
		};
		const fetchFidelities = async () => {
			loading--;
			const result = await getFidelities(null, 1);
			setFidelities(result.data);
			setLoading(loading !== 0);
		};
		fetchFidelities();
		fetchPrices();
	}, []);

	const getSimulatorMilesJSON = () => {
		let airline = fidelities.find(airline =>
			airline.fidelities.find(f => f.id == fidelitySelected.id)
		);
		let showModalQuickSaleProblem =
			quantMiles < fidelityPrice.minMilesAmount || quantMiles > fidelityPrice.maxMilesAmount;

		return {
			logged: true,
			referrer: ROUTE_REDIRECT_OFFER,
			quickSale: !showModalQuickSaleProblem,
			fidelityId: fidelitySelected.id,
			showModalQuickSaleProblem,
			currentStep: showModalQuickSaleProblem ? 1 : 2,
			price: fidelityPrice.price,
			quantMiles,
			errors: { quantMiles: "", price: "" },
			fidelity: {
				...fidelitySelected,
				value: fidelitySelected.id,
				label: airline.airlineAcronym,
				highlight: fidelitySelected.name,
				fidelities: [fidelitySelected]
			}
		};
	};

	const getRangeQuantMilesTracking = () => {
		let c = parseInt(quantMiles / 50000);
		return c * 50000 + " < x < " + (c + 1) * 50000;
	};

	const isValid = () => {
		setUserInteracted(true);
		if (
			step === 1 &&
			quantMiles >= fidelitySelected.valMinMiles &&
			quantMiles <= fidelitySelected.valMaxMiles &&
			fidelitySelected.id
		) {
			PubSub.publish("dataLayer", {
				event: "gaEvent",
				gaEventCategory: "Vender milhas",
				gaEventAction: "Venda rápida",
				gaEventLabel: "Quantidade de milhas",
				gaEventDetail: getRangeQuantMilesTracking()
			});

			if (
				quantMiles >= fidelityPrice.minMilesAmount &&
				quantMiles <= fidelityPrice.maxMilesAmount
			) {
				setStep(2); // Fluxo dentro do venda rapida
			} else {
				redirect();
			}
		} else if (step === 2) {
			redirect();
		}
	};

	const redirect = () => {
		localStorage.setItem("CreateOffer", JSON.stringify(getSimulatorMilesJSON()));

		window.history.pushState(ROUTE_REDIRECT_OFFER.toString(), document.title, ROUTE_REDIRECT_OFFER);
		if (getUserToken()) {
			window.location.href = ROUTE_REDIRECT_OFFER;
		} else {
			redirectToLogin(window);
		}
	};

	const onChangeFidelity = fidelity => {
		setFidelitySelected(fidelity);
		setFidelityPrice(prices.find(p => p.id_airline_program === fidelity.id));
	};

	const onStepBack = () => {
		setStep(1);
		setFidelitySelected(defaultFidelity);
		setQuantMiles("");
		setUserInteracted(false);
	};

	const contentStep =
		step === 1 ? (
			<QuickOfferFields
				{...{
					fidelities,
					onChangeFidelity,
					setQuantMiles,
					setUserInteracted,
					userInteracted,
					fidelitySelected,
					quantMiles,
					maxMilesAmount: fidelitySelected.valMaxMiles,
					minMilesAmount: fidelitySelected.valMinMiles
				}}
			/>
		) : (
			<QuickOfferTotal {...{ quantMiles, price: fidelityPrice.price }} />
		);

	return (
		<CardAction
			title="VENDA RÁPIDA"
			titleIcon="icon-max-finance-miles"
			button={step === 2 ? "Vender" : "Cotar agora"}
			buttonClick={loading ? undefined : isValid}
			buttonData={`quick-sale-${step === 1 ? `simulate-now` : `sell-now`}`}
			secondaryButton={step === 2 && !loading && "Fazer outra cotação"}
			secondaryButtonClick={onStepBack}
			secondaryButtonData="quick-sale-new-simulation"
		>
			{loading ? (
				<Loading width="120px" height="120px" />
			) : (
				<>
					{contentStep}
					<Item>Cadastro simplificado</Item>
					<Item>Prioridade na venda</Item>
				</>
			)}
		</CardAction>
	);
};

export default QuickOfferCard;
